import { Injector, runInInjectionContext, signal } from '@angular/core';
import { IDateRangeAsDates } from '@core/models/IDates';
import { FiltDimension, Filter, FilterCateg } from '@features/social-analysis/models/IFilters';
import { PageFiltersService } from '../services/page-filters.service';

export class PageFiltersState {
    selectedDates = signal<IDateRangeAsDates>({ startDate: null, endDate: null });
    appliedFilters = signal<Filter[]>([]);
    tempFilters = signal<Filter[]>([]);
    dimensions = signal<FilterCateg[]>([]);
    opts = signal<string[]>([]);
    forbiddenOpts: string[] = [];
    isLoading = signal(false);
    #http!: PageFiltersService;

    constructor(filterDims: FilterCateg[], injector: Injector) {
        this.dimensions.set(filterDims);
        runInInjectionContext(injector, () => (this.#http = new PageFiltersService()));
    }

    reqConfig(dim: FiltDimension, search: string | null = '') {
        this.#http.reqFilterOpts(this, dim, search);
    }

    resetFilters(filterDims: FilterCateg[]) {
        this.appliedFilters.set([]);
        this.tempFilters.set([]);
        this.dimensions.set(filterDims);
    }
}

export class SocialPageFilters extends PageFiltersState {
    override forbiddenOpts = ['tag']; // avoid displaying filter options. Ex: on dimension 'mediaType' hide the 'tag' option
}
